import React, { Component } from "react";
import { connect } from "react-redux";
import { reduxForm, formValueSelector } from "redux-form";
import { Form, Modal, FormGroup } from "react-bootstrap";

import Button from "../../../../components/common/button/Button";
import AddFilterBox from "./AddFilterBox";
import styles from "./Filters.scss";

import { getAdminList } from "../../../../actions/admin.actions";
import { searchCitiesAutocomplete } from "../../../../actions/cities.actions";
import { getProjectBudgetRateTypes } from "../../../../actions/dropdowns.actions";
import { getStatus } from "../../../../actions/project.actions";
import { fetchSkills, getCategories } from "../../../../actions/skills.actions";

import { getFilterFromRouteState } from "../../../../utils/parseQueries";

class Filters extends Component {
  constructor(props) {
    super(props);

    this.state = {
      show: props.show || false
    };

    this.handleClose = this.handleClose.bind(this);
    this.applyFilters = this.applyFilters.bind(this);
  }

  componentDidMount() {
    this.props.getStatus();
    this.props.getProjectBudgetRateTypes();
    this.props.getCategories();
    this.props.fetchSkills();
    this.props.getAdminList();
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.show !== nextProps.show) {
      this.setState({ show: nextProps.show });
    }
  }

  handleClose() {
    this.setState({ show: false }, this.props.onClose);
  }

  applyFilters() {
    this.handleClose();
  }

  render() {
    const { submitting, valid } = this.props;

    return (
      <Modal
        show={this.state.show}
        onHide={this.handleClose}
        dialogClassName={styles.modalContainer}
      >
        <Modal.Body className={styles.modalBody}>
          <Form onSubmit={this.props.handleSubmit}>
            <FormGroup>
              <div className={styles.title}>Filter Project Table</div>
              <div className={styles.dividerDouble} />
              <div className={styles.subtitle}>
                Find just what you’re looking for by creating filters for your
                current data set.
              </div>
              <div className={styles.filtersContainer}>
                <AddFilterBox
                  name="filters"
                  addText="Add Filter"
                  statusOptions={this.props.status}
                  budgetOptions={this.props.budgetTypes}
                  cities={this.props.cities}
                  onSearchCities={this.props.searchCitiesAutocomplete}
                  isLoadingCities={this.props.isLoadingCities}
                  skillsCategoriesOptions={this.props.categories}
                  skillsOptions={this.props.skills}
                  selectedSkillCategory={this.props.skillCategory}
                  tssAdminOptions={this.props.admins}
                  selectedLocation={this.props.location}
                />
              </div>
            </FormGroup>

            <div className={styles.dividerDouble} />

            <div className={styles.CTAContainer}>
              <Button
                isPrimary
                type="submit"
                label="View Results"
                onClick={this.applyFilters}
                isDisabled={!valid || submitting}
              />
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    );
  }
}

Filters = reduxForm({
  form: "projectsTableFilters",
  enableReinitialize: true,
  destroyOnUnmount: true
})(Filters);

const selector = formValueSelector("projectsTableFilters");
const getChild = _.property("skill_category");
const getLocation = _.property("location");
Filters = connect(
  state => {
    let skillCategory;
    const skillCategorySelector = selector(state, "filters");
    if (skillCategorySelector) {
      skillCategory = skillCategorySelector
        .map(getChild)
        .filter(e => e === 0 || e);
    }

    let location;
    const locationSelector = selector(state, "filters");
    if (locationSelector) {
      location = locationSelector.map(getLocation).filter(e => e === 0 || e);
      if (location && location.length > 0) {
        location = location[0];
      }
    }

    return {
      skillCategory,
      location,
      status: state.project.status,
      budgetTypes: state.dropdowns.projectBudgetRateTypes.data,
      cities: state.cities.cities.predictions,
      isLoadingCities: state.cities.cities.isLoading,
      categories: state.skills.categories.data,
      skills: state.skills.skills.data,
      admins: state.admin.admins,
      initialValues: getFilterFromRouteState(state, "filters")
    };
  },
  dispatch => {
    return {
      getStatus: () => dispatch(getStatus()),
      getProjectBudgetRateTypes: () => dispatch(getProjectBudgetRateTypes()),
      searchCitiesAutocomplete: query =>
        dispatch(searchCitiesAutocomplete(query)),
      getCategories: () => dispatch(getCategories()),
      fetchSkills: () => dispatch(fetchSkills()),
      getAdminList: () => dispatch(getAdminList())
    };
  }
)(Filters);

export default Filters;



// WEBPACK FOOTER //
// ./src/routes/admin/projects/components/Filters.js